import { createFileRoute } from '@tanstack/react-router'
import { GuidePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/de/ratgeber/$guideSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'guide', locale: 'de', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { guideSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <GuidePage guideSlug={guideSlug} />
    </CatalogProvider>
  )
}
